<template>
  <SendEmailRE />
</template>

<script>
import SendEmailRE from "@/components/auth/SendEmailResetEmail";
export default {
  components: {
    SendEmailRE: SendEmailRE,
  },
};
</script>

<style></style>
